<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :class="eventType === 'view' ? 'h550_dialog abow_dialog' : 'h600_dialog abow_dialog'"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="用户"
                    prop="userId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.userId"
                      filterable
                      clearable
                      placeholder="请选择用户"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in userOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.userName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="eventType === 'view'">
                <el-col :span="24">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditViewForm.provinceNames"
                      type="textarea"
                      rows="3"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogAddEditViewForm.cityNames"
                      type="textarea"
                      rows="3"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="区县">
                    <el-input
                      v-model="dialogAddEditViewForm.countyNames"
                      type="textarea"
                      rows="3"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="eventType !== 'view'"
            class="modal-box"
          >
            <h3 class="modal-title">
              区域信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="3">
                  <div class="search-box">
                    全部省区
                  </div>
                  <div class="left left-list-box">
                    <ul>
                      <li
                        v-for="(item,index) in provinceData"
                        :key="item.index"
                        :class="{'active':index==provinceCurrent}"
                        @dblclick="addToSetList(item, index, 'province')"
                        @click="leftCheckedFun(item, index, 'province')"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </el-col>
                <el-col style="width:85px;">
                  <div class="transfer-button">
                    <el-button
                      type="success"
                      plain
                      @click="addSetRightFun('province')"
                    >
                      添加
                    </el-button>
                    <el-button
                      type="warning"
                      plain
                      @click="deleteRightFun('province')"
                    >
                      删除
                    </el-button>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="search-box">
                    <i class="el-icon-success" />选择省区
                  </div>
                  <div class="right right-list-box">
                    <ul>
                      <draggable
                        :list="setProvinceData"
                        group="article"
                        class="dragArea"
                      >
                        <div
                          v-for="(element, index) in setProvinceData"
                          :key="index"
                          class="list-complete-item"
                          :class="{'active':index==setProvinceCurrent}"
                          @dblclick="deleteToSetList(element, index, 'province')"
                          @click="rightCheckedFun(element, index, 'province')"
                        >
                          <li class="employee">
                            {{ element.name }}
                          </li>
                        </div>
                      </draggable>
                    </ul>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="search-box">
                    全部城市
                  </div>
                  <div class="left left-list-box">
                    <ul>
                      <li
                        v-for="(item,index) in cityData"
                        :key="item.index"
                        :class="{'active':index==cityCurrent}"
                        @dblclick="addToSetList(item, index, 'city')"
                        @click="leftCheckedFun(item, index, 'city')"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </el-col>
                <el-col style="width:85px;">
                  <div class="transfer-button">
                    <el-button
                      type="success"
                      plain
                      @click="addSetRightFun('city')"
                    >
                      添加
                    </el-button>
                    <el-button
                      type="warning"
                      plain
                      @click="deleteRightFun('city')"
                    >
                      删除
                    </el-button>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="search-box">
                    <i class="el-icon-success" />选择城市
                  </div>
                  <div class="right right-list-box">
                    <ul>
                      <draggable
                        :list="setCityData"
                        group="article"
                        class="dragArea"
                      >
                        <div
                          v-for="(element, index) in setCityData"
                          :key="index"
                          class="list-complete-item"
                          :class="{'active':index==setCityCurrent}"
                          @dblclick="deleteToSetList(element, index, 'city')"
                          @click="rightCheckedFun(element, index, 'city')"
                        >
                          <li class="employee">
                            {{ element.name }}
                          </li>
                        </div>
                      </draggable>
                    </ul>
                  </div>
                </el-col>

                <el-col :span="3">
                  <div class="search-box">
                    全部区县
                  </div>
                  <div class="left left-list-box">
                    <ul>
                      <li
                        v-for="(item,index) in countyData"
                        :key="item.index"
                        :class="{'active':index==countyCurrent}"
                        @dblclick="addToSetList(item, index, 'county')"
                        @click="leftCheckedFun(item, index, 'county')"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </el-col>
                <el-col style="width:85px;">
                  <div class="transfer-button">
                    <el-button
                      type="success"
                      plain
                      @click="addSetRightFun('county')"
                    >
                      添加
                    </el-button>
                    <el-button
                      type="warning"
                      plain
                      @click="deleteRightFun('county')"
                    >
                      删除
                    </el-button>
                  </div>
                </el-col>
                <el-col :span="3"> 
                  <div class="search-box">
                    <i class="el-icon-success" />选择区县
                  </div>
                  <div class="right right-list-box">
                    <ul>
                      <draggable
                        :list="setCountyData"
                        group="article"
                        class="dragArea"
                      >
                        <div
                          v-for="(element, index) in setCountyData"
                          :key="index"
                          class="list-complete-item"
                          :class="{'active':index==setCountyCurrent}"
                          @dblclick="deleteToSetList(element, index, 'county')"
                          @click="rightCheckedFun(element, index, 'county')"
                        >
                          <li class="employee">
                            {{ element.name }}
                          </li>
                        </div>
                      </draggable>
                    </ul>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { loadUserSelectDataApi } from '@/api/user'
import { initUserAreaApi, saveOrUpdateUserAreaApi } from '@/api/userArea'
export default {
  components: { draggable },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        userId: [ { required: true, message: '请选择用户', trigger: 'change' }]
      },
      userOptions: [],
      provinceData: [], // 省区数据源
      provinceChecked: null,
      provinceCurrent: -1,
      setProvinceData: [],
      setProvinceChecked: null,
      setProvinceCurrent: -1,
      cityData: [], // 城市数据源
      cityChecked: null,
      cityCurrent: -1,
      setCityData: [],
      setCityChecked: null,
      setCityCurrent: -1,
      countyData: [], // 城市数据源
      countyChecked: null,
      countyCurrent: -1,
      setCountyData: [],
      setCountyChecked: null,
      setCountyCurrent: -1
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.userOptions = []
        this.provinceData = []
        this.provinceChecked = null
        this.provinceCurrent = -1
        this.setProvinceData = []
        this.setProvinceChecked = null
        this.setProvinceCurrent = -1
        this.cityData = []
        this.cityChecked = null
        this.cityCurrent = -1
        this.setCityData = []
        this.setCityChecked = null
        this.setCityCurrent = -1
        this.countyData = []
        this.countyChecked = null
        this.countyCurrent = -1
        this.setCountyData = []
        this.setCountyChecked = null
        this.setCountyCurrent = -1
        this.dialogAddEditViewForm = {
          userName: '',
          userId: '',
          provinceIds: '',
          provinceNames: '',
          cityIds: '',
          cityNames: '',
          countyIds: '',
          countyNames: ''
        }
        if (this.eventType !== 'view') {
          this.initUserData()
          this.getProvinceData()
        }
        if (this.eventType !== 'add') {
          this.initPageData()
        }
      }
    },
  },
  methods: {
    // 加载数据
    initPageData () {
      initUserAreaApi({ id: this.dataId }).then(res => {
        const { data } = res
        for(let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        if (this.eventType !== 'view') {
          let provinceNameArray = data.provinceNames.split(',')
          data.provinceIds.split(',').forEach((item, index) => {
            this.setProvinceData.push({ id: Number(item), name: provinceNameArray[index]})
          })
          this.getCityData(false)
          if (data.cityIds && data.cityIds.length > 0) {
            let cityNameArray = data.cityNames.split(',')
            data.cityIds.split(',').forEach((item, index) => {
              this.setCityData.push({ id: Number(item), name: cityNameArray[index]})
            })
            this.getCountyData(false)
          }
          if (data.countyIds && data.countyIds.length > 0) {
            let countyNameArray = data.countyNames.split(',')
            data.countyIds.split(',').forEach((item, index) => {
              this.setCountyData.push({ id: Number(item), name: countyNameArray[index]})
            })
          }
        }
        this.loading = false
      })
    },
    // 初始用户数据
    initUserData(){
      loadUserSelectDataApi({status: 1}).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.userOptions.push({ label: item.name, data: item.id })
          if (this.eventType === 'add') {
            this.loading = false
          }
        })
      })
    },
    // 获取省区清单
    getProvinceData () {
      loadAreaDataApi({ parentId: 1 }).then(response => {
        const { data } = response
        this.provinceData = data
        this.provinceChecked = null
        this.provinceCurrent = -1
      })
    },
    // 获取全部城市
    getCityData (isClear) {
      if (isClear) {
        this.cityData = []
        this.cityChecked = null
        this.cityCurrent = -1
        this.setCityData = []
        this.setCityChecked = null
        this.setCityCurrent = -1
        this.countyData = []
        this.countyChecked = null
        this.countyCurrent = -1
        this.setCountyData = []
        this.setCountyChecked = null
        this.setCountyCurrent = -1
      }
      let provinceIds = ''
      this.setProvinceData.forEach(item => {
        provinceIds += ',' + item.id
      })
      if (provinceIds.length > 0) {
        loadAreaDataApi({ parentIds: provinceIds }).then(response => {
          const { data } = response
          this.cityData = data
        })
      }
    },
    // 获取全部区县
    getCountyData (isClear) {
      if (isClear) {
        this.countyData = []
        this.countyChecked = null
        this.countyCurrent = -1
        this.setCountyData = []
        this.setCountyChecked = null
        this.setCountyCurrent = -1
      }
      let cityIds = ''
      this.setCityData.forEach(item => {
        cityIds += ',' + item.id
      })
      if (cityIds.length > 0) {
        loadAreaDataApi({ parentIds: cityIds }).then(response => {
          const { data } = response
          this.countyData = data
        })
      }
    },
    leftCheckedFun (item, index, region) {
      if (region === 'province') {
        this.provinceCurrent = index
        this.provinceChecked = item
      } else if (region === 'city') {
        this.cityCurrent = index
        this.cityChecked = item
      } else if (region === 'county') {
        this.countyCurrent = index
        this.countyChecked = item
      }
    },
    rightCheckedFun (item, index, region) {
      if (region === 'province') {
        this.setProvinceCurrent = index
        this.setProvinceChecked = item
      } else if (region === 'city') {
        this.setCityCurrent = index
        this.setCityChecked = item
      } else if (region === 'county') {
        this.setCountyCurrent = index
        this.setCountyChecked = item
      }
    },
    addSetRightFun (region) {
      if (region === 'province') {
        if (!this.provinceChecked) {
          this.$message.error('请选择要添加的省区')
          return
        }
        let hasItem = false
        this.setProvinceData.forEach(item => {
          if (item.id === this.provinceChecked.id) {
            hasItem = true
          }
        })
        if (!hasItem) {
          this.setProvinceData.push(this.provinceChecked)
          this.getCityData(true)
        }
      } else if (region === 'city') {
        if (!this.cityChecked) {
          this.$message.error('请选择要添加的城市')
          return
        }
        let hasItem = false
        this.setCityData.forEach(item => {
          if (item.id === this.cityChecked.id) {
            hasItem = true
          }
        })
        if (!hasItem) {
          this.setCityData.push(this.cityChecked)
          this.getCountyData(true)
        }
      } else if (region === 'county') {
        if (!this.countyChecked) {
          this.$message.error('请选择要添加的区县')
          return
        }
        let hasItem = false
        this.setCountyData.forEach(item => {
          if (item.id === this.countyChecked.id) {
            hasItem = true
          }
        })
        if (!hasItem) {
          this.setCountyData.push(this.countyChecked)
        }
      }
    },
    deleteRightFun (region) {
      if (region === 'province') {
        if (!this.setProvinceChecked) {
          this.$message.error('请选择要删除的省区')
          return
        }
        let index = this.setProvinceData.indexOf(this.setProvinceChecked)
        if (index >= 0) {
          this.setProvinceCurrent = -1
          this.setProvinceData.splice(index, 1)
          this.getCityData(true)
        }
      } else if (region === 'city') {
        if (!this.setCityChecked) {
          this.$message.error('请选择要删除的城市')
          return
        }
        let index = this.setCityData.indexOf(this.setCityChecked)
        if (index >= 0) {
          this.setCityCurrent = -1
          this.setCityData.splice(index, 1)
          this.getCountyData(true)
        }
      } else if (region === 'county') {
        if (!this.setCountyChecked) {
          this.$message.error('请选择要删除的区县')
          return
        }
        let index = this.setCountyData.indexOf(this.setCountyChecked)
        if (index >= 0) {
          this.setCountyCurrent = -1
          this.setCountyData.splice(index, 1)
        }
      }
    },
    addToSetList (item, index, region) {
      this.leftCheckedFun(item, index, region)
      this.addSetRightFun(region)
    },
    deleteToSetList (item, index, region) {
      this.rightCheckedFun(item, index, region)
      this.deleteRightFun(region)
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          // 省区
          if (this.setProvinceData.length < 1) {
            this.$message.error('请选择省区')
            return false
          } else {
            let provinceIds = ''
            let provinceNames = ''
            this.setProvinceData.forEach(item => {
              provinceIds += ',' + item.id
              provinceNames += ',' + item.name
            })
            provinceIds = provinceIds.substring(1)
            provinceNames = provinceNames.substring(1)
            this.dialogAddEditViewForm.provinceIds = provinceIds
            this.dialogAddEditViewForm.provinceNames = provinceNames
          }
          // 城市
          let cityIds = ''
          let cityNames = ''
          if (this.setCityData.length > 0) {
            this.setCityData.forEach(item => {
              cityIds += ',' + item.id
              cityNames += ',' + item.name
            })
            cityIds = cityIds.substring(1)
            cityNames = cityNames.substring(1)
          }
          this.dialogAddEditViewForm.cityIds = cityIds
          this.dialogAddEditViewForm.cityNames = cityNames
          // 区县
          let countyIds = ''
          let countyNames = ''
          if (this.setCountyData.length > 0) {
            this.setCountyData.forEach(item => {
              countyIds += ',' + item.id
              countyNames += ',' + item.name
            })
            countyIds = countyIds.substring(1)
            countyNames = countyNames.substring(1)
          }
          this.dialogAddEditViewForm.countyIds = countyIds
          this.dialogAddEditViewForm.countyNames = countyNames
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '用户区域','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateUserAreaApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.search-box{
  width:100%;
  margin-bottom:10px;
  margin-top: 10px;
  .el-icon-success{
    color:#67c23a;
    font-size: 16px;
    vertical-align: middle;
    display: inline-block;
    margin-right:5px;
    margin-top:-2px;
  }
}
.left {
  width:100%;
  height: 250px;
  border: 1px solid #ccc;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-bottom:10px;
}
.right {
  width: 100%;
  height: 250px;
  border: 1px solid #ccc;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-bottom:10px;
}
.left {
  padding: 5px 0;
}
.left li{
  padding:0 5px;
}
.left-list-box {
  overflow-x: hidden;
  overflow: auto;
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
  line-height: 20px;
}
.transfer-button {
  width: 70px;
  float: left;
  padding-top:120px;
  text-align: center;
}
.transfer-button .el-button {
  margin: 10px 0;
  flex:1
}
.right {
  width: 100%;
}
.right-list,
.list-complete-item {
   width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
  display: flex;
  overflow-x: hidden;

}
.right-list li ,.list-complete-item li{
  padding: 0 5px;
  margin: 0;
  line-height: 24px;
  border-bottom: 1px solid #ccc;
  flex:1;
}
li.order {
 flex:0 1 60px;
 width:60px;
  border-right: 1px solid #ccc;
}
 li.employee {
  border-right: 1px solid #ccc;
  text-align: center;
}
.right-list>li{
  background: #efefef;
}
.li:hover {
  background: #b2e1ff;
}
.active {
  background: #7fceff;
}
.right-list-box {
  background: #67c23a1a;
  overflow-x: hidden;
  overflow: auto;
}
</style>
